import translations from './i18n';
const ext = {
  th: {
    ufa_footer_slogan: 'สล็อตออนไลน์ ระบบออโต้ทันสมัย ฝาก – ถอน ภายใน 3 วิ',
  },
  en: {
    ufa_footer_slogan: 'Online slots with a modern auto system, deposit – withdraw within 3 seconds',
  },
  zh: {
    ufa_footer_slogan: '在线老虎机，现代自动系统，3 秒内存款 – 提款',
  },
  ja: {
    ufa_footer_slogan: 'オンラインスロット、最新の自動システム、3 秒以内に入金 – 出金',
  },
  my: {
    ufa_footer_slogan: 'အွန်လိုင်းဆလော့၊ ခေတ်မီအော်တိုစနစ်၊ ၃ စက္ကန့်အတွင်း ငွေသွင်း – ငွေထုတ်',
  },
  lo: {
    ufa_footer_slogan: 'ສລ໋ອດອອນລາຍ ລະບົບອັດຕະໂນມັດທັນສະໄໝ ຝາກ – ຖອນ ພາຍໃນ 3 ວິນາທີ',
  },
};
Object.keys(ext).forEach((l) => { translations[l] = Object.assign({}, translations[l], ext[l]); });
export default ext;
